import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { groupItemIdentifierStruct } from "@/modules/groups/api/resources/groupsIdentifierStruct";

import { subtaskIdentifierStruct } from "../subtask/subtaskIdentifierStruct";

import { taskIdentifierStruct } from "./tasksIdentifierStructs";

export const taskItemResourceStruct = createResourceStruct({
  identifier: taskIdentifierStruct,
  attributes: sup.object({
    date: sup.string(),
    name: sup.string(),
    pointsNumber: sup.integer(),
    deadline: sup.nullable(sup.string()),
  }),
  relationships: sup.object({
    subtasks: sup.object({
      data: sup.array(subtaskIdentifierStruct),
    }),
    userGroups: sup.object({
      data: sup.array(groupItemIdentifierStruct),
    }),
  }),
});

export const tasksResourceStruct = sup.array(taskItemResourceStruct);
